import TrainIconSvg from "@mui/icons-material/Train"

const TrainIcon = props => <TrainIconSvg {...props} />

export default TrainIcon
